import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=4b10bc68&"
import script from "./Comment.vue?vue&type=script&lang=js&"
export * from "./Comment.vue?vue&type=script&lang=js&"
import style0 from "./Comment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports